import { useTheme } from "../lib/theme";

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      <path
        d="M13.5 9.6A5.6 5.6 0 016.4 2.5a5.6 5.6 0 107.1 7.1z"
        fill="currentColor"
      />
    </svg>
  );
}

function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
      <circle cx="8" cy="8" r="3.1" fill="currentColor" />
      <path
        d="M8 1v1.8M8 13.2V15M1 8h1.8M13.2 8H15M3.1 3.1l1.3 1.3M11.6 11.6l1.3 1.3M12.9 3.1l-1.3 1.3M4.4 11.6l-1.3 1.3"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * Moon | sun switch. Only the inactive side is a button, labelled with its
 * destination: a label that states the current theme reads as a status, and
 * users click it expecting the opposite.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useTheme();
  const next = theme === "dark" ? "light" : "dark";

  return (
    <div className="theme-switch" data-theme-state={theme}>
      <span className="theme-switch-thumb" aria-hidden="true" />
      <span className="theme-switch-face" aria-hidden="true">
        <MoonIcon />
      </span>
      <span className="theme-switch-face" aria-hidden="true">
        <SunIcon />
      </span>
      <button
        type="button"
        className="theme-switch-hit"
        onClick={() => setTheme(next)}
        aria-label={`Switch to ${next} theme`}
        title={`Switch to ${next} theme`}
        aria-pressed={theme === "dark"}
      />
    </div>
  );
}
